module.exports = __webpack_public_path__ + "static/img/ic_gy_fw_xjb.d3b18e4c.png";